import { SmartLink } from '../../fragments/smart-link/SmartLink';
import IconUI from '../../fragments/icon/IconUI';

// Level 3 — the nested flyout that opens off a Level 2 link.
export default function NavLevel3Menu({ children, uri, id }) {
  const parentLink =
    uri && uri != '/' ? { id: '__parent__', uri, label: 'Overview' } : null;
  const items = parentLink ? [parentLink, ...children] : children;

  return (
    <div className="NavLevel3Menu-container" id={id}>
      <ul className="NavLevel3Menu-list">
        {items.slice(0, 7).map((grandchild) => (
          <li className={`NavLevel3Menu-item`} key={grandchild.id}>
            <SmartLink
              href={grandchild.uri}
              className="NavLevel3Menu-link headingStrong"
            >
              <span className="NavLevel3Menu-linkText">
                {grandchild.label}
                {grandchild.excerpt && (
                  <span className="NavLevel3Menu-excerpt step--2">
                    {grandchild.excerpt}
                  </span>
                )}
              </span>
              <IconUI icon="chevronRight" />
            </SmartLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
